import ErrorCode from "@/constants/error-codes";

export default interface PageResponse<T> {
    data: T
    pageNumber: number
    pageSize: number
    totalPages: number
    totalRecords: number
}

export interface BackendResponseType {
    status: "success" | "fail";
    data?: any;
    errorCode?: ErrorCode;
    errorMessage?: string | null;
    errorLevel?: ErrorLevel | null;

}

export type PaginationProps = {
    numberOfPages: number;
    changePageHandler: (page: number) => void;
    currentPage: number;
};


export enum ErrorLevel {
    USER = 0,
    DEBUG = 1,
    EXTERNAL = 2,
}